// NOTE: By setting a webpack public path dynamically, we can build a
// single bundle and deploy it into two different AWS accounts each with
// their own CDN, or use it locally against webpack dev server.

/*eslint-disable */
__webpack_public_path__ = window.__webpack_public_path__
